"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.latLngContain = void 0;
// Return if LatLng c inside the boundary of northease (ne) and southwest sw
exports.latLngContain = function (c, ne, sw) {
    if (!c || !ne || !sw)
        return false;
    return ne.lat > c.lat && sw.lat < c.lat && ne.lng > c.lng && sw.lng < c.lng;
};
